import { motion } from 'framer-motion';
import ispaiLogoMark from "@/assets/ispai-logo-mark.png";

interface GibletThinkingIndicatorProps {
  statusText?: string;
}

export const GibletThinkingIndicator = ({ statusText }: GibletThinkingIndicatorProps) => {
  return (
    <div className="flex items-start gap-3 px-4 py-3">
      <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 overflow-hidden">
        <img src={ispaiLogoMark} alt="Giblet" className="w-8 h-8 object-cover rounded-full" style={{ imageRendering: 'crisp-edges' as any }} />
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">Giblet</span>
          <motion.div 
            className="flex gap-1"
            initial={{ opacity: 0.5 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
          >
            <motion.span
              className="w-1.5 h-1.5 rounded-full bg-primary"
              animate={{ y: [0, -4, 0] }}
              transition={{ duration: 0.6, repeat: Infinity, delay: 0 }}
            />
            <motion.span
              className="w-1.5 h-1.5 rounded-full bg-primary"
              animate={{ y: [0, -4, 0] }}
              transition={{ duration: 0.6, repeat: Infinity, delay: 0.15 }}
            />
            <motion.span
              className="w-1.5 h-1.5 rounded-full bg-primary"
              animate={{ y: [0, -4, 0] }}
              transition={{ duration: 0.6, repeat: Infinity, delay: 0.3 }}
            />
          </motion.div>
        </div>
        <p className="text-sm text-muted-foreground">
          {statusText || "Thinking..."}
        </p>
      </div>
    </div>
  );
};
